import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import BeatLoader from 'react-spinners/BeatLoader';
import TagInput from '~/../components/shared/components/tag_input';
import CSVReader from '~/../components/communities_manage/components/csv_reader';
import Table from '~/../components/communities_manage/components/table';
import { inviteCommunityMembers } from '~/../components/shared/utils/api';

import { takeEmailColumn, validateInputEmails } from '~/../components/communities_manage/components/members/member_utils';
import { validateEmail } from '~/../components/shared/utils/helpers';

const InviteMembers = ({ formData }) => {
  const [link, setLink] = useState(`https://voray.com/${formData.slug}`);
  const [message, setMessage] = useState('');
  const [feedback, setFeedback] = useState({});
  const feedbackTimer = useRef(null);
  const [isLoading, setLoading] = useState(false);
  const [inviteType, setInviteType] = useState('emails');
  const [emailsFromInput, setEmailsFromInput] = useState([]);
  const [CSVData, setCSVData] = useState([]);
  const [CSVEmails, setCSVEmails] = useState([]);

  let clearChildState = null;

  const assignClearChildState = (childClearStateFunc) => {
    clearChildState = childClearStateFunc;
  };

  useEffect(() => {
    let emailsList = [];

    if (CSVData.length) {
      emailsList = takeEmailColumn(handleFeedback, CSVData);
      emailsList.length === 0 && setCSVData([]);
    }

    setCSVEmails(emailsList);
  }, [CSVData]);

  const handleInviteSend = () => {
    if (isEmpty(CSVEmails) && isEmpty(emailsFromInput)) {
      handleFeedback('danger', 'Please enter emails or add CSV to send invites');
      return;
    }

    const emails = isEmpty(CSVEmails) ? emailsFromInput : CSVEmails;

    if (!validateInputEmails(emails, handleFeedback)) return;
    if (isEmpty(message)) {
      handleFeedback('danger', 'Please enter a valid message', 'message');
      return;
    }

    const body = { emails, message, slug: formData.slug };

    inviteCommunityMembers(body, handleSuccess, handleFailure);
    setLoading(true);
  };

  const handleSuccess = () => {
    setLoading(false);
    setCSVData([]);
    setEmailsFromInput([]);
    handleFeedback('green', 'Emails were successfully sent', 'invite');
    clearChildState();
  };


  const handleFailure = ({ message }) => {
    setLoading(false);
    handleFeedback('red', message, 'invite');
  };

  const handleFeedback = (type, msg, field = 'emails') => {
    setFeedback({ type, msg, field });
    feedbackTimer.current = setTimeout(() => setFeedback({}), 7000);
  };

  const renderEmailInput = () => {
    return (
      <TagInput
        placeholder='Type the email address and press ENTER to confirm...'
        styles={'mt-10 mw-70r h-100'}
        onChange={emails => setEmailsFromInput(emails)}
        value={emailsFromInput}
        onEnter={validateEmail}
        passClearStateFunc={assignClearChildState}
      />
    );
  };

  const renderCsvInput = () => {
    if (CSVData.length > 0) {
      return (
        <div className='clear'>
          <Table headers={'Emails'} data={takeEmailColumn(() => {}, CSVData)} />
        </div>
      );
    }

      return (
        <div className='mw-70r'>
          <CSVReader
            setCSVData={setCSVData}
            resetInputEmails={() => setEmailsFromInput([])}
          />
        </div>
      );
  };

  return (
    <div className='ml-20'>
      <p className='h4 w3'>Invite Members</p>
      <p className='t3 w3 mt-50'>Share a link</p>
      <input
        className='form-control border mw-70r mt-5'
        defaultValue={link}
        type='link'
        placeholder='Community link'
        aria-label='Community link'
        onChange={e => setLink(e.target.value)}
      />

      <div className='block mt-20 mb-20'>
        <input
          id='btn-check-1'
          type='radio'
          className='btn-check'
          name='options'
          defaultChecked={inviteType === 'emails'}
        />
        <label
          className='btn btn-outline-primary mr-40'
          htmlFor='btn-check-1'
          onClick={() => { setInviteType('emails'); setCSVData([]); }}
        >
          Emails
        </label>
        <input
          id='btn-check-2'
          type='radio'
          className='btn-check'
          autoComplete="off"

          name='options'
          defaultChecked={inviteType === 'csv'}
        />
        <label
          className='btn btn-outline-primary'
          htmlFor='btn-check-2'
          onClick={() => { setInviteType('csv'); setEmailsFromInput([]); }}
        >
          CSV
        </label>
      </div>

      { inviteType === 'emails' ? renderEmailInput() : renderCsvInput() }
      { feedback.field === 'emails' && <span className={`${feedback.type} mt-5 block`}>{feedback.msg}</span>}

      <p className='t3 w3 mt-20'>Add a message</p>
      <textarea
        className='form-control mw-70r mt-5'
        placeholder='Let those you invite know why you are inviting them to this community'
        rows='5'
        onChange={e => setMessage(e.target.value)}
      />
      { feedback.field === 'message' && <span className={`${feedback.type} mt-5 block`}>{feedback.msg}</span>}

      <div className='mt-10 mw-70r mb-60'>
        <button
          className='btn btn-main btn-send-invites right'
          onClick={handleInviteSend}
          disabled={isLoading}
        >
          Send Invites
        </button>
        { isLoading &&
          <BeatLoader color='#3d898b' speedMultiplier={0.5} className='invite-loading'/>}
      </div>
      { feedback.field === 'invite' && <span className={`${feedback.type} mt-5 block right`}>{feedback.msg}</span>}
    </div>
  );
};

InviteMembers.propTypes = {
  formData: PropTypes.object.isRequired
};

export default InviteMembers;
